import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import { convertBooleansToStrings } from './swift-id-applicant.transformer';
import type { SwiftIdApplicantCollection } from './swift-id-applicant.types';

export function swiftIdApplicantBackend(): Backend<SwiftIdApplicantCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    maxBatchSize: 1,
    fetch: (authUid, ids, query, order) => {
      if (!ids || ids.length !== 1) {
        throw new Error('SwiftIdApplicant fetch requires exactly one ID');
      }

      return {
        endpoint: 'swift-id/applicant.php',
        method: 'GET',
        isGaf: true,
        params: {
          id: ids[0],
        },
      };
    },
    push: (_, swiftIdApplicant) => {
      const { applicationId, ...applicantFields } = swiftIdApplicant;

      return {
        endpoint: 'swift-id/applicant.php',
        method: 'POST',
        isGaf: true,
        payload: {
          applicationId,
          applicantData: convertBooleansToStrings(applicantFields),
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
